<template>
    <div id="demo">
        <h3>
            Feature Or Components Demo
        </h3>
        <div class="ui divider"></div>
        <div v-if="datetimerange_val">
            {{ $moment(datetimerange_val[0]).format('YYYY-MM-DDTHH:mm:ss+08:00') }}
            <br>
            {{ $moment(datetimerange_val[1]).format('YYYY-MM-DDTHH:mm:ss+08:00') }}
        </div>

        <div class="ui buttons">
            <div class="ui button" @click='$bus.$emit("add_image_print_job", print_job_1)'>
                Image Printer (A4, 6 in one page) * 1 page
            </div>
            <div class="ui button" @click='$bus.$emit("add_image_print_job", print_job_2)'>
                Image Printer (100x100, 1 in one page) * 6 page
            </div>
        </div>
        <div class="ui buttons">
            <div class="ui button" @click='$bus.$emit("document_print", {
                documents: [
                    {
                        name: "1",
                        html: "<h1>Test</h1>"
                    },
                    {
                        name: "2",
                        html: "<h1>Test</h1>"
                    },
                ],
                paper_type: "A4",
                numbers_of_one_page: 1
            })'>
                Document Printer (A4, 6 in one page) * 1 page
            </div>
            <div class="ui button" @click='$bus.$emit("document_print", {
                documents: [
                    {
                        name: "1",
                        html: "<h1>Test</h1>"
                    },
                    {
                        name: "2",
                        html: "<h1>Test</h1>"
                    },
                ],
                paper_type: "100x100",
                numbers_of_one_page: 1
            })'>
                Document Printer (100x100, 1 in one page) * 6 page
            </div>
        </div>
        <div class="ui divider"></div>
        <div class="ui segment">
            <h3 class="ui header">WebAudio</h3>
            <WebAudio :channel="'provider_index_web_audio'" :allow_overlay_play="false" :show_demo="true"></WebAudio>
            <div class="ui basic button" @click="$bus.$emit('provider_index_web_audio', 'play_sound', 'ok')">
                PlaySound
            </div>
            <div class="ui basic button" @click="$bus.$emit('provider_index_web_audio', 'play_file', 'AlertSound.mp3')">
                PlayFile
            </div>
        </div>
        <div class="ui segment">
            <h3 class="ui header">Receipts</h3>
            <div class="ui basic button" @click="$bus.$emit('Receipts', 'A5')">
                呼叫列印 A5 in A5 by event bus
            </div>
            <div class="ui basic button" @click="$bus.$emit('Receipts', 'A4')">
                呼叫列印 A5 in A4 by event bus
            </div>
            <Receipts
                :channel_name="'Receipts'"
                :assigned_core_waybills="demo_core_waybills"
                :title="'測試範例簽收單'"
                :sub_title="'http://by-express.com'"
                :customer_service_hotline="'0800-000-123'"
                :logistician="{name: '9999999 配送人員'}"
                :logo_url="'/images/by_express_logo.jpg'"
                :show_contents="false">
            </Receipts>
        </div>
        <div class="ui segment">
            <h3 class="ui header">FileUploader</h3>
            <button class="ui basic button" @click="$bus.$emit('FileUploader1', 'FileUploader1', 'open_file_browser')">呼叫file browser</button>
            <FileUploader :channel="'FileUploader1'"></FileUploader>
            <FileUploader :channel="'FileUploader2'" :theme="'compact'"></FileUploader>
        </div>
        <div class="ui segment">
            <h3 class="ui header">CoreWaybillsLabelSvg</h3>
            <CoreWaybillsLabelSvg
                :label_name="'1231'"
                :authentication_token="'12312'"
            >
            </CoreWaybillsLabelSvg>
        </div>
        <div class="ui segment">
            <h3 class="ui header">OrderSummary</h3>
            <OrderSummary
                :channel_name="'OrderSummary'"
                :assigned_core_waybills="demo_core_waybills"
                :title="'測試範例簽收單'"
                :sub_title="'http://by-express.com'"
                :customer_service_hotline="'0800-000-123'"
                :logistician="{name: '9999999 配送人員'}"
                :logo_url="'/images/by_express_logo.jpg'"
                :show_buttons="true"
                :show_contents="true">
            </OrderSummary>
        </div>
        <div class="ui segment">
            <h3 class="ui header">CheckSummary</h3>
            <CheckSummary
                :scope="'provider'"
                :default_search_params="{
                    latest_condition_name: 'current_handover',
                    latest_condition_polarity: true,
                    pagination: false,
                }"
                :channel_name="'CheckSummary'"
                :title="'貨物交予 點交單'"
                :sub_title="'http://by-express.com'"
                :customer_service_hotline="'123456'"
                :logo_url="'/images/by_express_logo.jpg'"
                :show_buttons="true"
                :show_contents="true">
            </CheckSummary>
        </div>
        <div class="ui segment">
            <h3 class="ui header">Supervisor</h3>
            <Supervisor>
            </Supervisor>
        </div>
    </div>
</template>

<script>
import WebAudio from "@toolbox/web_audio/main.vue"
import Receipts from "@toolbox/receipts/main.vue"
import OrderSummary from "@toolbox/order_summary/main.vue"
import CheckSummary from "@toolbox/check_summary/main.vue"
import FileUploader from "@toolbox/file_uploader/main.vue"
import CoreWaybillsLabelSvg from "@toolbox/core_waybills_label_svg/main.vue"
import Supervisor from "@toolbox/supervisor/main.vue"

export default {
    name: "ProviderDemo",
    props: {
    },
    data() {
        return {
            is_loading: false,
            datetimerange_val: null,
            print_job_1: {
                note: "Demo Print Job 1",
                images: [
                    {
                        name: "1",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    },
                    {
                        name: "2",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    },
                    {
                        name: "3",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    },
                    {
                        name: "4",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    },
                    {
                        name: "5",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    },
                    {
                        name: "6",
                        src: "https://img.discogs.com/xrWPcqdGvmhXzsn9jCOcI3W--1A=/fit-in/396x374/filters:strip_icc():format(jpeg):mode_rgb():quality(90)/discogs-images/R-6262272-1415048734-4399.jpeg.jpg"
                    }
                ],
                paper_type: "A4",
                numbers_of_one_page: 6,
            },
            print_job_2: {
                note: "Demo Print Job 2",
                images: [
                    {
                        name: "1",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    },
                    {
                        name: "2",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    },
                    {
                        name: "3",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    },
                    {
                        name: "4",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    },
                    {
                        name: "5",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    },
                    {
                        name: "6",
                        src: "https://sc01.alicdn.com/kf/HTB12X0mGFXXXXXQXVXXq6xXFXXXL/2215311/HTB12X0mGFXXXXXQXVXXq6xXFXXXL.jpg"
                    }
                ],
                paper_type: "100x100",
                numbers_of_one_page: 1,
            },
            demo_core_waybills: [
                {
                    number: "886600130504",
                    original_number: "這個欄位接受至多15字湊字湊字湊",
                    consignee_name: "這個欄位接受至多15字湊字湊字湊",
                    consignee_phone: "這個欄位接受至多15字湊字湊字湊",
                    consignee_address: "這個欄位接受至多30字湊字湊字湊字湊字湊字湊字湊字湊字湊字湊字",
                    original_waybill_number: "這個欄位接受至多15字湊字湊字湊",
                    sender_name: "這個欄位接受至多15字湊字湊字湊",
                    sender_phone: "這個欄位接受至多15字湊字湊字湊",
                    sender_address: "這個欄位接受至多30字湊字湊字湊字湊字湊字湊字湊字湊字湊字湊字",
                    pieces: 99999,
                    measurement: 99999,
                    collection: 99999,
                    goods_name: "品名：女用灰色上衣L",
                    shipping_date: "2017-12-13",
                    shipping_period: "00~24",
                    shipping_note: "這個欄位接受至多10字",
                    charge: 99999,
                    payment_type: "cash_by_sender",
                },
                {
                    number: "886600130505",
                    original_number: "775600130505",
                    consignee_name: "一般使用範例（資料量普通）",
                    consignee_phone: "0912345678",
                    consignee_address: "桃園市桃園區樹林八街24-2號3樓",
                    original_waybill_number: "7756655665",
                    sender_name: "陳宜靜",
                    sender_phone: "0987654321",
                    sender_address: "桃園市桃園區桃園火車站",
                    pieces: 50,
                    measurement: 20,
                    collection: 1500,
                    goods_name: "女用手錶",
                    shipping_date: "2017-12-13",
                    shipping_period: "08~13",
                    shipping_note: "週六配送 上樓",
                    charge: 500,
                    payment_type: "cash_by_consignee",
                },
                {
                    number: "886600130506",
                    consignee_name: "空單",
                    consignee_phone: null,
                    consignee_address: null,
                    original_waybill_number: null,
                    sender_name: null,
                    sender_phone: null,
                    sender_address: null,
                    pieces: null,
                    measurement: null,
                    collection: null,
                    goods_name: null,
                    shipping_date: null,
                    shipping_period: null,
                    shipping_note: null,
                    charge: null,
                    payment_type: null,
                },
            ],
        }
    },
    mounted() {
        var that = this;
        that.$bus.$on('FileUploader1', (from, event_name, data) => {
            // if (from == "file_uploader") {
            switch (event_name) {
                case "uploaded_file":
                    console.log("your uploaded file is: " + data);
                    break;
                case "uploading":
                    console.log("uploading");
                    console.log(data);
                    break;
                case "upload complete":
                    console.log("complete");
                    console.log(data);
                    break;
                case "upload failed":
                    console.log("failed");
                    break;
            }
            // }
        })
        that.$bus.$on('FileUploader2', (from, event_name, data) => {
            // if (from == "file_uploader") {
            switch (event_name) {
                case "uploaded_file":
                    console.log("your uploaded file is: " + data);
                    break;
                case "uploading":
                    console.log("uploading");
                    console.log(data);
                    break;
                case "upload complete":
                    console.log("complete");
                    console.log(data);
                    break;
                case "upload failed":
                    console.log("failed");
                    break;
            }
            // }
        })
    },
    watch: {
    },
    methods: {
    },
    components: {
        WebAudio,
        Receipts,
        FileUploader,
        CoreWaybillsLabelSvg,
        OrderSummary,
        CheckSummary,
        Supervisor,
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
</style>
